/* eslint-disable */
import createIcon from '../createIcon';

const IconRightOutlined = createIcon({
  name: 'icon-right-outlined',
  content: '<path d="M702.207841 512.318606L386.787803 196.898569l-45.242066 45.242066L611.723709 512.318606l-270.177972 270.177971 45.242066 45.242066 315.420038-315.420037z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconRightOutlined;
